export const FILE_VARS = ["--file1", "--file2", "--file3"];

export function fileColor(n) {
  if (n >= 1 && n <= 3) return `hsl(var(${FILE_VARS[n - 1]}))`;
  return "hsl(var(--muted-foreground))";
}

export function fileTint(n) {
  if (n >= 1 && n <= 3) return `hsl(var(${FILE_VARS[n - 1]}) / 0.12)`;
  return "hsl(var(--muted) / 0.5)";
}

const VERIFY_PALETTE = ["#0B78B3", "#7c3aed", "#c2255c", "#0ca678", "#e8590c", "#1971c2", "#9c36b5", "#2b8a3e"];
export function verifyColor(key) {
  let h = 0;
  for (const ch of String(key)) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return VERIFY_PALETTE[h % VERIFY_PALETTE.length];
}
